export const InvestorBidStatus: Record<string, string> = {
  PENDING: 'PENDING',
  INVITED: 'INVITED',
  DECLINED: 'DECLINED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED' 
} as const;

export const InvestorBidStatusDisplay = {
  [InvestorBidStatus.PENDING]: 'Pending',
  [InvestorBidStatus.INVITED]: 'Invited',
  [InvestorBidStatus.DECLINED]: 'Declined',
  [InvestorBidStatus.ACCEPTED]: 'Accepted',
  [InvestorBidStatus.REJECTED]: 'Rejected'
} as const;

export const QueueActionsButtonText: Record<keyof typeof InvestorBidStatus, string> = {
  [InvestorBidStatus.PENDING]: 'Invite',
  [InvestorBidStatus.INVITED]: 'Edit',
  [InvestorBidStatus.ACCEPTED]: 'Edit',
  [InvestorBidStatus.DECLINED]: 'Reinvite',
} as const;

export const QueueActions = {
  INVITE: 'INVITE',
  EDIT: 'EDIT',
  REMOVE_FROM_QUEUE: 'REMOVE_FROM_QUEUE',
  RECALL_INVITATION: 'RECALL_INVITATION',
} as const;

export const QueueActionsDisplay = {
  [QueueActions.INVITE]: 'Invite',
  [QueueActions.EDIT]: 'Edit',
  [QueueActions.REMOVE_FROM_QUEUE]: 'Remove from queue',
  [QueueActions.RECALL_INVITATION]: 'Recall invitation',
} as const;

// TODO fix typing
export const QueueActionsDropdownOptions: any = {
  [InvestorBidStatus.PENDING]: [
    { text: QueueActionsDisplay.EDIT, value: QueueActions.EDIT },
    { text: QueueActionsDisplay.REMOVE_FROM_QUEUE, value: QueueActions.REMOVE_FROM_QUEUE },
  ],
  [InvestorBidStatus.INVITED]: [
    { text: QueueActionsDisplay.RECALL_INVITATION, value: QueueActions.RECALL_INVITATION },
  ],
  [InvestorBidStatus.DECLINED]: [
    { text: QueueActionsDisplay.EDIT, value: QueueActions.EDIT },
    { text: QueueActionsDisplay.REMOVE_FROM_QUEUE, value: QueueActions.REMOVE_FROM_QUEUE },
  ],
};

export type QueueActionOption = {
  text: string;
  value: keyof typeof QueueActions; 
};

// commented out for now because it was throwing a lint error
// export type QueueActionsDropdownOptionsType = {
//   [key in keyof typeof InvestorBidStatus]: QueueActionOption[]; 
// };

export const FeeUnits = {
  DOLLARS_PER_WDC: 'DOLLARS_PER_WDC',
  PERCENT_OF_ITC: 'PERCENT_OF_ITC',
  PERCENT_OF_BUDGET: 'PERCENT_OF_BUDGET',
  FLAT_FEE: 'FLAT_FEE'
} as const;

//for investor queue table display
export const FeeUnitsDisplay = {
  [FeeUnits.DOLLARS_PER_WDC]: '$/Wdc',
  [FeeUnits.PERCENT_OF_ITC]: '% ITC',
  [FeeUnits.PERCENT_OF_BUDGET]: '% Budget',
  [FeeUnits.FLAT_FEE]: '$ Flat fee'
} as const;

//for investor queue modal display to add and edit fees
export const FeeUnitsDisplayShort = {
  [FeeUnits.DOLLARS_PER_WDC]: '/Wdc',
  [FeeUnits.PERCENT_OF_ITC]: 'ITC',
  [FeeUnits.PERCENT_OF_BUDGET]: 'Budget',
  [FeeUnits.FLAT_FEE]: 'Flat fee'
} as const;

//for the bid grid display
export const FeeUnitsDisplayBidGrid = {
  [FeeUnits.DOLLARS_PER_WDC]: '/ Wdc',
  [FeeUnits.PERCENT_OF_ITC]: 'of ITC value',
  [FeeUnits.PERCENT_OF_BUDGET]: 'of budget',
  [FeeUnits.FLAT_FEE]: 'flat fee'
} as const;

export const FeeUnitsDropdownOptions = [
  { key: FeeUnits.DOLLARS_PER_WDC, text: FeeUnitsDisplay[FeeUnits.DOLLARS_PER_WDC], value: FeeUnits.DOLLARS_PER_WDC },
  { key: FeeUnits.PERCENT_OF_ITC, text: FeeUnitsDisplay[FeeUnits.PERCENT_OF_ITC], value: FeeUnits.PERCENT_OF_ITC },
  { key: FeeUnits.PERCENT_OF_BUDGET, text: FeeUnitsDisplay[FeeUnits.PERCENT_OF_BUDGET], value: FeeUnits.PERCENT_OF_BUDGET },
  { key: FeeUnits.FLAT_FEE, text: FeeUnitsDisplay[FeeUnits.FLAT_FEE], value: FeeUnits.FLAT_FEE }
];

export const StorageFeeUnits = {
  DOLLARS_PER_KWH: 'DOLLARS_PER_KWH',
  FLAT_FEE: 'FLAT_FEE'
} as const;

export const StorageFeeUnitsDisplay = {
  [StorageFeeUnits.DOLLARS_PER_KWH]: '$/kWh',
  [StorageFeeUnits.FLAT_FEE]: '$ Flat fee'
} as const;

export const StorageFeeUnitsDisplayShort = {
  [StorageFeeUnits.DOLLARS_PER_KWH]: '/kWh',
  [StorageFeeUnits.FLAT_FEE]: 'Flat fee'
} as const;

export const StorageFeeUnitsDropdownOptions = [
  { key: StorageFeeUnits.DOLLARS_PER_KWH, text: StorageFeeUnitsDisplay[StorageFeeUnits.DOLLARS_PER_KWH], value: StorageFeeUnits.DOLLARS_PER_KWH },
  { key: StorageFeeUnits.FLAT_FEE, text: StorageFeeUnitsDisplay[StorageFeeUnits.FLAT_FEE], value: StorageFeeUnits.FLAT_FEE }
];

export const InvestorBidState = {
  AWAITING_BID: 'AWAITING_BID',
  DECLINED_TO_BID: 'DECLINED_TO_BID',
  BID_REJECTED: 'BID_REJECTED',
  CONVERSATION_ENDED: 'CONVERSATION_ENDED',
  HAS_ALL_PROJECTS_RESPONSE: 'HAS_ALL_PROJECTS_RESPONSE',
} as const;

export const InvestorBidStateDisplay = {
  [InvestorBidState.AWAITING_BID]: 'Awaiting bid...',
  [InvestorBidState.DECLINED_TO_BID]: 'Declined to bid',
  [InvestorBidState.CONVERSATION_ENDED]: 'Conversation ended',
  [InvestorBidState.BID_REJECTED]: 'Conversation ended',
  [InvestorBidState.HAS_ALL_PROJECTS_RESPONSE]: 'See below',
} as const;

